import React from 'react';

export const AttentionIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z"
        fill="#FFAE34"
        fillOpacity="0.05"
      />
      <path
        d="M50 30C50 41.0457 41.0457 50 30 50C18.9543 50 10 41.0457 10 30C10 18.9543 18.9543 10 30 10C41.0457 10 50 18.9543 50 30Z"
        fill="#FFAE34"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 20C30.663 20 31.2989 20.2634 31.7678 20.7322C32.2366 21.2011 32.5 21.837 32.5 22.5V31.25C32.5 31.913 32.2366 32.5489 31.7678 33.0178C31.2989 33.4866 30.663 33.75 30 33.75C29.337 33.75 28.7011 33.4866 28.2322 33.0178C27.7634 32.5489 27.5 31.913 27.5 31.25V22.5C27.5 21.837 27.7634 21.2011 28.2322 20.7322C28.7011 20.2634 29.337 20 30 20Z"
        fill="#FAB957"
      />
      <path
        d="M32.5 37.5C32.5 38.163 32.2366 38.7989 31.7678 39.2678C31.2989 39.7366 30.663 40 30 40C29.337 40 28.7011 39.7366 28.2322 39.2678C27.7634 38.7989 27.5 38.163 27.5 37.5C27.5 36.837 27.7634 36.2011 28.2322 35.7322C28.7011 35.2634 29.337 35 30 35C30.663 35 31.2989 35.2634 31.7678 35.7322C32.2366 36.2011 32.5 36.837 32.5 37.5Z"
        fill="#FAB957"
      />
    </svg>
  );
};
